import { render } from "./_ButtonsArea.vue?vue&type=template&id=0acfeebe&scoped=true&lang=en"
import script from "./_ButtonsArea.vue?vue&type=script&lang=js"
export * from "./_ButtonsArea.vue?vue&type=script&lang=js"

import "./_ButtonsArea.vue?vue&type=style&index=0&id=0acfeebe&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acfeebe"]])

export default __exports__